import { render, staticRenderFns } from "./IframeLoader.vue?vue&type=template&id=1bcf7e35&"
import script from "./IframeLoader.vue?vue&type=script&lang=js&"
export * from "./IframeLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports